import type { FormFieldValidation } from '../../common/types/form/form-fields';
import { findChoice, getLinkedChoices } from '../choice/utils';
import type { IssueFieldData } from '../types/field-data';
import type { ApiFormChoicesResponse } from '../types/form-choices';
import { type FormQuestion, FormQuestionType } from '../types/proforma-form';

// Will only add the validation that have actual values (no undefined)
export const convertValidation = (
	question: FormQuestion,
	fieldData?: IssueFieldData,
	formChoices?: ApiFormChoicesResponse,
): FormFieldValidation => {
	const { validation } = question;
	const result: FormFieldValidation = {};

	if (validation.mxc !== undefined) {
		result.maximumCharacters = validation.mxc;
	}
	if (validation.mxw !== undefined) {
		result.maximumWords = validation.mxw;
	}
	if (validation.mxn !== undefined) {
		result.maximumNumber = validation.mxn;
	}
	if (validation.mxd !== undefined) {
		result.maximumDate = validation.mxd;
	}
	if (validation.mxt !== undefined) {
		result.maximumTime = validation.mxt;
	}
	if (validation.mxs !== undefined) {
		result.maximumOptionSelections = validation.mxs;
	}
	if (validation.mnc !== undefined) {
		result.minimumCharacters = validation.mnc;
	}
	if (validation.mnw !== undefined) {
		result.minimumWords = validation.mnw;
	}
	if (validation.mnn !== undefined) {
		result.minimumNumber = validation.mnn;
	}
	if (validation.mnd !== undefined) {
		result.minimumDate = validation.mnd;
	}
	if (validation.mnt !== undefined) {
		result.minimumTime = validation.mnt;
	}
	if (validation.mns !== undefined) {
		result.minimumOptionSelections = validation.mns;
	}
	if (validation.rgx !== undefined) {
		result.regexValidation = {
			pattern: validation.rgx.p,
			mismatchMessage: validation.rgx.m,
		};
	}
	if (validation.rq !== undefined) {
		result.required = validation.rq;
	}
	if (validation.ch !== undefined && question) {
		const requiredChoiceId = validation.ch;
		const isCascading = question.type === FormQuestionType.ChoiceCascading;

		const linkedChoices = getLinkedChoices(question, formChoices);

		if (fieldData?.asyncRequiredChoice) {
			result.requiredOption = {
				id: fieldData.asyncRequiredChoice.id,
				label: fieldData.asyncRequiredChoice.label,
			};
		} else if (linkedChoices) {
			const choice = findChoice(linkedChoices, requiredChoiceId, isCascading);
			result.requiredOption = {
				id: choice.id,
				label: choice.label,
			};
		} else if (question.choices) {
			const choice = findChoice(question.choices, requiredChoiceId, isCascading);
			result.requiredOption = {
				id: choice.id,
				label: choice.label,
			};
		}
		// the option could not be found at all, so we don't need to validate it
	}
	if (validation.wh !== undefined) {
		result.wholeNumbersOnly = validation.wh;
	}

	return result;
};
